module.exports = __webpack_public_path__ + "img/TSC-logo.0a7f108c.png";